import'./wad-rgpd';
import'./animations';

document.addEventListener('DOMContentLoaded', function () {

});
